import { useMemo } from 'react';
import { Image as DatoImage } from 'react-datocms';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { Image as ImageType, ResponsiveImage } from 'services/graphql';

import styles from './ImageBlock.module.css';

interface ImageBlockRecord extends CdaStructuredTextRecord {
  image?: ResponsiveImage | ImageType | null;
  imageSubtitle?: string;
}

export default function ImageBlock({ image, imageSubtitle }: ImageBlockRecord) {
  const imageData = useMemo(() => {
    if (!image) return null;

    const img = 'responsiveImage' in image ? image.responsiveImage : image;
    if (!img) return null;

    return img.src ? img : { ...img, src: (img as ImageType).url };
  }, [image]);

  if (!imageData && !imageSubtitle) return null;

  return (
    <figure className={styles.picture}>
      {imageData && (
        <DatoImage
          data={imageData}
          className={styles.image}
        />
      )}
      {imageSubtitle && <figcaption className={styles.caption}>{imageSubtitle}</figcaption>}
    </figure>
  );
}
